module.exports = __webpack_public_path__ + "media/new5.c0797e6d.mp4";